module.exports = __webpack_public_path__ + "img/transportCertificate.45b9df21.jpg";